import React, { useState, useEffect, useContext, useRef } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import { formatDate, formatTime } from "../../../constants/helper";
import { AuthContext } from "../../../contexts/AuthContext";
import { tempUrl, useStateContext } from "../../../contexts/ContextProvider";
import { Loader } from "../../../components";
import {
  Box,
  TextField,
  Typography,
  Divider,
  Button,
  ButtonGroup,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
} from "@mui/material";
import { Container, Col, Row, Form } from "react-bootstrap";
import LogoPerusahaanNoColor from "../../../assets/LogoPerusahaanNoColor.jpeg";
import jsPDF from "jspdf";
import angkaTerbilang from "@develoka/angka-terbilang-js";
import PrintIcon from "@mui/icons-material/Print";
import SearchIcon from "@mui/icons-material/Search";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import useScreenWidth from "../../../hooks/useScreenWidth";

const TampilHutangDendaFidusia = () => {
  const screenSize = useScreenWidth();
  const reportTemplateRef = useRef(null);
  const { user, dispatch, setting } = useContext(AuthContext);
  const { id, idAngsuranChild } = useParams();

  const [pengajuanFidusiaId, setPengajuanFidusiaId] = useState("");
  const [isBayarTerakhir, setIsBayarTerakhir] = useState("");
  const [namaCustomer, setNamaCustomer] = useState("");
  const [namaCustomerSplit, setNamaCustomerSplit] = useState([]);
  const [noPerjanjian, setNoPerjanjian] = useState("");
  const [tglAng, setTglAng] = useState("");
  const [jamAng, setJamAng] = useState("");
  const [noMesin, setNoMesin] = useState("");
  const [nopol, setNopol] = useState("");
  const [no, setNo] = useState("");

  const navigate = useNavigate();
  const [previewPdf, setPreviewPdf] = useState(false);
  const [open, setOpen] = useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const textRight = {
    textAlign: screenSize >= 650 && "right",
  };

  // Data Angsuran
  const [tglJatuhTempo, setTglJatuhTempo] = useState("");
  const [angModal, setAngModal] = useState("");
  const [angBunga, setAngBunga] = useState("");
  const [angPerBulan, setAngPerBulan] = useState("");

  // Data Inputan
  const [tglBayar, setTglBayar] = useState("");
  const [tglBayarTeks, setTglBayarTeks] = useState("");
  const [keterlambatan, setKeterlambatan] = useState("");
  const [noKwitansi, setNoKwitansi] = useState("");
  const [keterangan, setKeterangan] = useState("");
  const [hutangDendaBefore, setHutangDendaBefore] = useState("");
  const [hutangDenda, setHutangDenda] = useState("");
  const [bayar, setBayar] = useState("");

  // Data Percepatan
  const [tenor, setTenor] = useState("");
  const [penerimaanAngsuran, setPenerimaanAngsuran] = useState({});
  const [kodeCOAAngsuran, setKodeCOAAngsuran] = useState("");

  const [isPost, setIsPost] = useState(false);
  const [loading, setLoading] = useState(false);

  let todayDate = new Date();
  let tempTodayMonth;
  switch (todayDate.getMonth() + 1) {
    case 1:
      tempTodayMonth = "JANUARI";
      break;
    case 2:
      tempTodayMonth = "FEBRUARI";
      break;
    case 3:
      tempTodayMonth = "MARET";
      break;
    case 4:
      tempTodayMonth = "APRIL";
      break;
    case 5:
      tempTodayMonth = "MEI";
      break;
    case 6:
      tempTodayMonth = "JUNI";
      break;
    case 7:
      tempTodayMonth = "JULI";
      break;
    case 8:
      tempTodayMonth = "AGUSTUS";
      break;
    case 9:
      tempTodayMonth = "SEPTEMBER";
      break;
    case 10:
      tempTodayMonth = "OKTOBER";
      break;
    case 11:
      tempTodayMonth = "NOVEMBER";
      break;
    case 12:
      tempTodayMonth = "DESEMBER";
      break;
    default:
      break;
  }

  const handleGeneratePdf = () => {
    const doc = new jsPDF({
      format: "a4",
      unit: "px",
    });

    doc.html(reportTemplateRef.current, {
      async callback(doc) {
        window.open(URL.createObjectURL(doc.output("blob")));
      },
      html2canvas: { scale: 0.44 },
    });
  };

  useEffect(() => {
    getPenerimaanHutangDendaFidusiaById();
  }, []);

  const getPenerimaanHutangDendaFidusiaById = async () => {
    if (id) {
      const penerimaanHutangDendaFidusia = await axios.post(
        `${tempUrl}/penerimaanHutangDendaFidusias/${id}`,
        {
          _id: user.id,
          token: user.token,
        }
      );
      setPenerimaanAngsuran(penerimaanHutangDendaFidusia.data);
      setPengajuanFidusiaId(
        penerimaanHutangDendaFidusia.data.pengajuanfidusia.id
      );
      setIsBayarTerakhir(penerimaanHutangDendaFidusia.data.isBayarTerakhir);
      setNamaCustomer(
        penerimaanHutangDendaFidusia.data.pengajuanfidusia.customer.namaCustomer
      );

      let words =
        penerimaanHutangDendaFidusia.data.pengajuanfidusia.customer.namaCustomer.split(
          " "
        );
      let result = [];

      for (let i = 0; i < words.length; i += 2) {
        result.push(words.slice(i, i + 2));
      }
      setNamaCustomerSplit(result);

      let newTglAng = new Date(
        penerimaanHutangDendaFidusia.data.pengajuanfidusia.tglAng
      );
      setTglAng(
        formatDate(penerimaanHutangDendaFidusia.data.pengajuanfidusia.tglAng)
      );
      setNoPerjanjian(penerimaanHutangDendaFidusia.data.noPerjanjian);
      setNoMesin(penerimaanHutangDendaFidusia.data.pengajuanfidusia.noMesin);
      setNopol(penerimaanHutangDendaFidusia.data.pengajuanfidusia.nopol);
      setTenor(penerimaanHutangDendaFidusia.data.pengajuanfidusia.tenor);
      let tempDateName;
      switch (newTglAng.getMonth() + 1) {
        case 1:
          tempDateName = "JANUARI";
          break;
        case 2:
          tempDateName = "FEBRUARI";
          break;
        case 3:
          tempDateName = "MARET";
          break;
        case 4:
          tempDateName = "APRIL";
          break;
        case 5:
          tempDateName = "MEI";
          break;
        case 6:
          tempDateName = "JUNI";
          break;
        case 7:
          tempDateName = "JULI";
          break;
        case 8:
          tempDateName = "AGUSTUS";
          break;
        case 9:
          tempDateName = "SEPTEMBER";
          break;
        case 10:
          tempDateName = "OKTOBER";
          break;
        case 11:
          tempDateName = "NOVEMBER";
          break;
        case 12:
          tempDateName = "DESEMBER";
          break;
        default:
          break;
      }

      setNo(penerimaanHutangDendaFidusia.data.no);
      let newTglJatuhTempo = new Date(
        penerimaanHutangDendaFidusia.data.tglJatuhTempo
      );
      setTglJatuhTempo(
        formatDate(penerimaanHutangDendaFidusia.data.tglJatuhTempo)
      );
      setAngModal(parseInt(penerimaanHutangDendaFidusia.data.angModal));
      setAngBunga(parseInt(penerimaanHutangDendaFidusia.data.angBunga));
      setAngPerBulan(penerimaanHutangDendaFidusia.data.angPerBulan);
      let newTglBayar = new Date(penerimaanHutangDendaFidusia.data.tglBayar);
      setTglBayar(
        penerimaanHutangDendaFidusia.data.tglBayar &&
          formatDate(penerimaanHutangDendaFidusia.data.tglBayar)
      );
      switch (newTglBayar.getMonth() + 1) {
        case 1:
          tempDateName = "JANUARI";
          break;
        case 2:
          tempDateName = "FEBRUARI";
          break;
        case 3:
          tempDateName = "MARET";
          break;
        case 4:
          tempDateName = "APRIL";
          break;
        case 5:
          tempDateName = "MEI";
          break;
        case 6:
          tempDateName = "JUNI";
          break;
        case 7:
          tempDateName = "JULI";
          break;
        case 8:
          tempDateName = "AGUSTUS";
          break;
        case 9:
          tempDateName = "SEPTEMBER";
          break;
        case 10:
          tempDateName = "OKTOBER";
          break;
        case 11:
          tempDateName = "NOVEMBER";
          break;
        case 12:
          tempDateName = "DESEMBER";
          break;
        default:
          break;
      }
      let tempTglBayar = `${newTglBayar.getDate().toLocaleString("en-US", {
        minimumIntegerDigits: 2,
        useGrouping: false,
      })} ${tempDateName} ${newTglBayar.getFullYear()}`;
      setTglBayarTeks(tempTglBayar);
      setNoKwitansi(penerimaanHutangDendaFidusia.data.noKwitansi);
      setKeterangan(penerimaanHutangDendaFidusia.data.keterangan);
      setHutangDendaBefore(penerimaanHutangDendaFidusia.data.hutangDendaBefore);
      setHutangDenda(penerimaanHutangDendaFidusia.data.hutangDenda);
      setBayar(penerimaanHutangDendaFidusia.data.bayar);
      const diffTime = Math.abs(newTglBayar - newTglJatuhTempo);
      let diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
      if (newTglBayar > newTglJatuhTempo) {
        setKeterlambatan(diffDays);
      }
      setIsPost(penerimaanHutangDendaFidusia.data.isPost);
      setKodeCOAAngsuran(
        `${penerimaanHutangDendaFidusia.data.coa.kodeCOA} - ${penerimaanHutangDendaFidusia.data.coa.namaCOA}`
      );

      let tglCreatedAngsuran = new Date(
        penerimaanHutangDendaFidusia.data.updatedAt
      );
      const timeString = formatTime(tglCreatedAngsuran);
      setJamAng(timeString);
    }
  };

  const deleteHutangDendaFidusia = async () => {
    setLoading(true);
    try {
      await axios.post(`${tempUrl}/batalPenerimaanHutangDendaFidusia/${id}`, {
        pengajuanFidusiaId,
        no,
        hutangDendaBefore,
        bayar,
        hutangDenda,
        isBayarTerakhir,
        _id: user.id,
        token: user.token,
        kodeCabang: user.cabang.id,
      });
      navigate(`/daftarHutangDendaFidusia`);
    } catch (error) {
      if (error.response.data.message.includes("foreign key")) {
        alert(`${idAngsuranChild} tidak bisa dihapus karena sudah ada data!`);
      }
    }
    setLoading(false);
  };

  if (loading) {
    return <Loader />;
  }

  return (
    <Container>
      <Button
        variant="outlined"
        color="secondary"
        onClick={() => navigate(`/daftarHutangDendaFidusia`)}
        sx={{ marginLeft: 2, marginTop: 4 }}
      >
        {"< Kembali"}
      </Button>

      <Box sx={downloadButtons}>
        <ButtonGroup variant="outlined" color="secondary">
          {bayar > 0 && (
            <Button
              color="primary"
              startIcon={<SearchIcon />}
              onClick={() => {
                setPreviewPdf(!previewPdf);
              }}
            >
              CETAK
            </Button>
          )}
        </ButtonGroup>
      </Box>

      {bayar > 0 && previewPdf && (
        <div>
          <Button
            variant="outlined"
            startIcon={<PrintIcon />}
            onClick={handleGeneratePdf}
          >
            CETAK
          </Button>
          <div ref={reportTemplateRef} style={cetakContainerKwitansiAngsuran}>
            <img
              src={LogoPerusahaanNoColor}
              alt="LogoPerusahaanNoColor"
              style={{ width: "70px" }}
            />
            <p style={cetakCenter}>{setting.namaPerusahaan}</p>
            <p style={cetakCenter}>
              {setting.alamatPerusahaan} ({setting.kabupatenPerusahaan}){" "}
              {setting.kotaPerusahaan}
            </p>
            <p style={cetakCenter}>NO. TELP. {setting.teleponPerusahaan}</p>
            <hr style={{ marginBottom: "20px" }} />
            <div style={{ display: "flex" }}>
              <div>
                <p style={cetakText}>Tanggal & Waktu</p>
              </div>
              <div style={{ marginLeft: "24px" }}>
                <p style={cetakText}>
                  : {tglBayar} {jamAng}
                </p>
              </div>
            </div>
            <div style={{ display: "flex" }}>
              <div>
                <p style={cetakText}>No. Kwitansi</p>
              </div>
              {/* <div style={{ marginLeft: "48px" }}> */}
              <div style={{ marginLeft: "50px" }}>
                <p style={cetakText}>: {noKwitansi}</p>
              </div>
            </div>
            <div style={{ marginTop: "10px" }}>
              <p style={cetakCenterBold}>BUKTI PEMBAYARAN HUTANG DENDA</p>
            </div>
            <div style={{ marginTop: "10px" }}>
              {namaCustomerSplit.map((user, index) => {
                if (index === 0) {
                  return (
                    <div style={{ display: "flex" }}>
                      <div>
                        <p style={cetakText}>Nasabah</p>
                      </div>
                      {/* <div style={{ marginLeft: "66px" }}> */}
                      <div style={{ marginLeft: "74px" }}>
                        <p style={cetakText}>
                          : {user[0]} {user[1]}
                        </p>
                      </div>
                    </div>
                  );
                } else {
                  return (
                    <div style={{ display: "flex" }}>
                      <div>
                        <p style={cetakTextHidden}>Nasabah</p>
                      </div>
                      {/* <div style={{ marginLeft: "66px" }}> */}
                      <div style={{ marginLeft: "68px" }}>
                        <p style={cetakTextNamaBarisSelanjutnya}>
                          {user[0]} {user[1]}
                        </p>
                      </div>
                    </div>
                  );
                }
              })}
              <div style={{ display: "flex" }}>
                <div>
                  <p style={cetakText}>Tgl. Pembayaran</p>
                </div>
                <div style={{ marginLeft: "22px" }}>
                  <p style={cetakText}>: {tglBayarTeks}</p>
                </div>
              </div>
              <div style={{ display: "flex" }}>
                <div>
                  <p style={cetakText}>No. Perjanjian</p>
                </div>
                {/* <div style={{ marginLeft: "38px" }}> */}
                <div style={{ marginLeft: "42px" }}>
                  <p style={cetakText}>: {noPerjanjian}</p>
                </div>
              </div>
              <div style={{ display: "flex" }}>
                <div>
                  <p style={cetakText}>Tgl. Jatuh Tempo</p>
                </div>
                <div style={{ marginLeft: "22px" }}>
                  <p style={cetakText}>: {tglAng.slice(0, 2)}</p>
                </div>
              </div>
              <div style={{ display: "flex" }}>
                <div>
                  <p style={cetakText}>No. Pol</p>
                </div>
                {/* <div style={{ marginLeft: "74px" }}> */}
                <div style={{ marginLeft: "84px" }}>
                  <p style={cetakText}>: {nopol}</p>
                </div>
              </div>
              <div style={{ display: "flex" }}>
                <div>
                  <p style={cetakText}>No. Mesin</p>
                </div>
                {/* <div style={{ marginLeft: "60px" }}> */}
                <div style={{ marginLeft: "66px" }}>
                  <p style={cetakText}>: {noMesin}</p>
                </div>
              </div>
              <div style={{ display: "flex" }}>
                <div>
                  <p style={cetakText}>Angsuran Ke</p>
                </div>
                {/* <div style={{ marginLeft: "44px" }}> */}
                <div style={{ marginLeft: "48px" }}>
                  <p style={cetakText}>
                    : {no} ({angkaTerbilang(no)})
                  </p>
                </div>
              </div>
              <div style={{ display: "flex" }}>
                <div>
                  <p style={cetakText}>Tenor</p>
                </div>
                {/* <div style={{ marginLeft: "84px" }}> */}
                <div style={{ marginLeft: "94px" }}>
                  <p style={cetakText}>: {tenor}</p>
                </div>
              </div>
              <div style={{ display: "flex" }}>
                <div>
                  <p style={cetakText}>Metode Pembayaran</p>
                </div>
                {/* <div style={{ marginLeft: "2px" }}> */}
                <div style={{ marginLeft: "0px" }}>
                  <p style={cetakText}>
                    :{" "}
                    {penerimaanAngsuran.coa.kasBank === "KAS"
                      ? "TUNAI"
                      : "TRANSFER"}
                  </p>
                </div>
              </div>
            </div>
            <hr style={{ marginBottom: "20px" }} />
            <div style={cetakWrapper}>
              <p>Keterangan</p>
              <p>Nominal</p>
            </div>
            <hr style={{ marginTop: "0px" }} />
            <div style={cetakWrapperNoMarginTop}>
              <p>Hutang Denda</p>
              <p>{hutangDendaBefore.toLocaleString("de-DE")}</p>
            </div>
            <div style={cetakWrapperNoMarginTop}>
              <p>Bayar</p>
              <p>{bayar.toLocaleString("de-DE")}</p>
            </div>
            <hr style={{ marginTop: "0px" }} />
            <div style={cetakWrapperNoMarginTop}>
              <p>Hutang Denda Baru</p>
              <p>{hutangDenda.toLocaleString("de-DE")}</p>
            </div>
            <div style={cetakWrapperText}>
              <p>Nasabah,</p>
              <p>{setting.namaPerusahaan} ,</p>
            </div>
            <div style={cetakWrapperTextName}>
              <p style={{ marginLeft: "-50px" }}>
                {namaCustomer.split(" ")[0]} {namaCustomer.split(" ")[1]}
              </p>
              <p style={{ marginLeft: "-40px" }}>{user.username}</p>
            </div>
          </div>
        </div>
      )}

      <Box>
        <Typography color="#757575">Fidusia</Typography>
        <Typography variant="h4" sx={subTitleText}>
          Hutang Denda
        </Typography>
        <Divider sx={dividerStyle} />

        {isPost === false && (
          <Box sx={buttonModifierContainer}>
            <ButtonGroup variant="contained">
              {/* {user.tipeUser !== "ADMIN" && ( */}
              {/* <Button
                color="primary"
                startIcon={<EditIcon />}
                sx={{ textTransform: "none" }}
                onClick={() => {
                  navigate(
                    `/daftarHutangDendaFidusia/${id}/edit`
                  );
                }}
              >
                Ubah
              </Button> */}
              {/* )} */}
              <Button
                color="error"
                startIcon={<DeleteOutlineIcon />}
                sx={{ textTransform: "none" }}
                onClick={handleClickOpen}
              >
                Hapus
              </Button>
            </ButtonGroup>
          </Box>
        )}

        <Dialog
          open={open}
          onClose={handleClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">{`Hapus Data`}</DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-slide-description">
              {`Yakin ingin menghapus data ${no}?`}
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => deleteHutangDendaFidusia(id)}>Ok</Button>
            <Button onClick={handleClose}>Cancel</Button>
          </DialogActions>
        </Dialog>

        <Box sx={textFieldContainer}>
          <Box sx={textFieldWrapper}>
            <Row>
              <Col>
                <Form.Group
                  as={Row}
                  className="mb-3"
                  controlId="formPlaintextPassword"
                >
                  <Form.Label column sm="4" style={textRight}>
                    No :
                  </Form.Label>
                  <Col sm="8">
                    <Form.Control value={no} disabled />
                  </Col>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col>
                <Form.Group
                  as={Row}
                  className="mb-3"
                  controlId="formPlaintextPassword"
                >
                  <Form.Label column sm="4" style={textRight}>
                    Tgl. Jatuh Tempo :
                  </Form.Label>
                  <Col sm="8">
                    <Form.Control value={tglJatuhTempo} disabled />
                  </Col>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col>
                <Form.Group
                  as={Row}
                  className="mb-3"
                  controlId="formPlaintextPassword"
                >
                  <Form.Label column sm="4" style={textRight}>
                    Kode Kas :
                  </Form.Label>
                  <Col sm="8">
                    <Form.Control value={kodeCOAAngsuran} disabled />
                  </Col>
                </Form.Group>
              </Col>
            </Row>
          </Box>
          <Box sx={[textFieldWrapper, secondWrapper]}>
            <Row>
              <Col>
                <Form.Group
                  as={Row}
                  className="mb-3"
                  controlId="formPlaintextPassword"
                >
                  <Form.Label column sm="4" style={textRight}>
                    Angsuran Modal :
                  </Form.Label>
                  <Col sm="8">
                    <Form.Control
                      value={angModal.toLocaleString("de-DE")}
                      disabled
                    />
                  </Col>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col>
                <Form.Group
                  as={Row}
                  className="mb-3"
                  controlId="formPlaintextPassword"
                >
                  <Form.Label column sm="4" style={textRight}>
                    Angsuran Bunga :
                  </Form.Label>
                  <Col sm="8">
                    <Form.Control
                      value={angBunga.toLocaleString("de-DE")}
                      disabled
                    />
                  </Col>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col>
                <Form.Group
                  as={Row}
                  className="mb-3"
                  controlId="formPlaintextPassword"
                >
                  <Form.Label column sm="4" style={textRight}>
                    Angsuran / Bulan :
                  </Form.Label>
                  <Col sm="8">
                    <Form.Control
                      value={angPerBulan.toLocaleString("de-DE")}
                      disabled
                    />
                  </Col>
                </Form.Group>
              </Col>
            </Row>
          </Box>
        </Box>
        <Divider sx={dividerStyle} />
        <Box sx={textFieldContainer}>
          <Box sx={textFieldWrapper}>
            <Row>
              <Col>
                <Form.Group
                  as={Row}
                  className="mb-3"
                  controlId="formPlaintextPassword"
                >
                  <Form.Label column sm="4" style={textRight}>
                    Tgl. Bayar :
                  </Form.Label>
                  <Col sm="8">
                    <Form.Control value={tglBayar} disabled />
                  </Col>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col>
                <Form.Group
                  as={Row}
                  className="mb-3"
                  controlId="formPlaintextPassword"
                >
                  <Form.Label column sm="4" style={textRight}>
                    Keterlambatan :
                  </Form.Label>
                  <Col sm="8">
                    <Form.Control value={`${keterlambatan} hari`} disabled />
                  </Col>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col>
                <Form.Group
                  as={Row}
                  className="mb-3"
                  controlId="formPlaintextPassword"
                >
                  <Form.Label column sm="4" style={textRight}>
                    No. Kwitansi :
                  </Form.Label>
                  <Col sm="8">
                    <Form.Control value={noKwitansi} disabled />
                  </Col>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col>
                <Form.Group
                  as={Row}
                  className="mb-3"
                  controlId="formPlaintextPassword"
                >
                  <Form.Label column sm="4" style={textRight}>
                    Keterangan :
                  </Form.Label>
                  <Col sm="8">
                    <Form.Control value={keterangan} disabled />
                  </Col>
                </Form.Group>
              </Col>
            </Row>
          </Box>
          <Box sx={[textFieldWrapper, secondWrapper]}>
            <Row>
              <Col>
                <Form.Group
                  as={Row}
                  className="mb-3"
                  controlId="formPlaintextPassword"
                >
                  <Form.Label column sm="4" style={textRight}>
                    Hutang Denda :
                  </Form.Label>
                  <Col sm="8">
                    <Form.Control
                      value={hutangDendaBefore.toLocaleString("de-DE")}
                      disabled
                    />
                  </Col>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col>
                <Form.Group
                  as={Row}
                  className="mb-3"
                  controlId="formPlaintextPassword"
                >
                  <Form.Label column sm="4" style={textRight}>
                    Bayar :
                  </Form.Label>
                  <Col sm="8">
                    <Form.Control
                      value={bayar.toLocaleString("de-DE")}
                      disabled
                    />
                  </Col>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col>
                <Form.Group
                  as={Row}
                  className="mb-3"
                  controlId="formPlaintextPassword"
                >
                  <Form.Label column sm="4" style={textRight}>
                    Hutang Denda Baru :
                  </Form.Label>
                  <Col sm="8">
                    <Form.Control
                      value={hutangDenda.toLocaleString("de-DE")}
                      disabled
                    />
                  </Col>
                </Form.Group>
              </Col>
            </Row>
          </Box>
        </Box>
      </Box>
    </Container>
  );
};

export default TampilHutangDendaFidusia;

const subTitleText = {
  fontWeight: "900",
};

const dividerStyle = {
  pt: 4,
  mb: 2,
};

const textFieldContainer = {
  display: "flex",
  flexDirection: {
    xs: "column",
    sm: "row",
  },
};

const textFieldWrapper = {
  display: "flex",
  flex: 1,
  flexDirection: "column",
};

const labelInput = {
  fontWeight: "600",
  marginLeft: 1,
};

const spacingTop = {
  mt: 4,
};

const secondWrapper = {
  marginLeft: {
    md: 4,
  },
  marginTop: {
    md: 0,
    xs: 4,
  },
};

const downloadButtons = {
  mt: 4,
  mb: 4,
  display: "flex",
  flexWrap: "wrap",
  justifyContent: "center",
};

const buttonModifierContainer = {
  mt: 4,
  mb: 4,
  display: "flex",
  flexWrap: "wrap",
  justifyContent: "center",
};

const cetakContainer = {
  fontSize: "14px",
  letterSpacing: "0.01px",
  fontFamily: "sans-serif",
  width: "300px",
  padding: "20px",
};

const cetakContainerSuratKeteranganLunas = {
  fontSize: "14px",
  letterSpacing: "0.01px",
  fontFamily: "sans-serif",
  width: "1000px",
  padding: "20px",
};

const cetakContainerKwitansiAngsuran = {
  fontSize: "14px",
  letterSpacing: "0.01px",
  fontFamily: "sans-serif",
  width: "330px",
  padding: "20px",
  // marginLeft: "35px",
  marginLeft: "15px",
};

const cetakWrapper = {
  // fontSize: "12px",
  fontSize: "14px",
  display: "flex",
  justifyContent: "space-between",
};

const cetakWrapperNoMarginTop = {
  // fontSize: "12px",
  fontSize: "14px",
  display: "flex",
  justifyContent: "space-between",
  marginTop: "-10px",
};

const cetakCenter = {
  // fontSize: "12px",
  fontSize: "14px",
  textAlign: "center",
  marginTop: "0px",
  marginBottom: "0px",
};

const cetakCenterBold = {
  textAlign: "center",
  marginTop: "0px",
  marginBottom: "0px",
  fontWeight: "700",
  // fontSize: "12px",
  fontSize: "14px",
};

const cetakCenterBoldBig = {
  textAlign: "center",
  marginTop: "0px",
  marginBottom: "0px",
  fontWeight: "700",
  fontSize: "25px",
};

const cetakTextHidden = {
  // fontSize: "12px",
  fontSize: "14px",
  marginTop: "0px",
  marginBottom: "0px",
  visibility: "hidden",
};

const cetakTextNamaBarisSelanjutnya = {
  // fontSize: "12px",
  fontSize: "14px",
  marginTop: "0px",
  marginBottom: "0px",
  paddingLeft: "6px",
};

const cetakText = {
  // fontSize: "12px",
  fontSize: "14px",
  marginTop: "0px",
  marginBottom: "0px",
};

const cetakWrapperTotal = {
  fontSize: "12px",
  display: "flex",
  justifyContent: "space-between",
  marginTop: "-10px",
  marginBottom: "10px",
};

const cetakWrapperText = {
  // fontSize: "12px",
  fontSize: "14px",
  display: "flex",
  justifyContent: "space-around",
};

const cetakWrapperTextName = {
  // fontSize: "12px",
  fontSize: "14px",
  display: "flex",
  justifyContent: "space-around",
  marginTop: "80px",
};

const colorRed = {
  color: "red",
};
